import { render, staticRenderFns } from "./priceStrategyGroupList.vue?vue&type=template&id=2ddbfe5c"
import script from "./priceStrategyGroupList.vue?vue&type=script&lang=js"
export * from "./priceStrategyGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports